<div class="page-shell">
    <div class="page">
        <div class="hero">
            <div class="hero-text">
                <span class="eyebrow">Atlas</span>
                <h2>Choose your subscription</h2>
                <p>Select a plan to continue to secure checkout.</p>
            </div>
            <div class="hero-panel">
                <div class="step-pill">Subscription</div>
                <div class="hero-title">Atlas Subscription</div>
                <div class="hero-subtitle">Pick the plan that fits your rollout.</div>
            </div>
        </div>

        <div class="content">
            @if (!tenantId) {
            <section class="card">
                <div class="card-header">
                    <h3>We could not find your tenant</h3>
                    <p>Return to the portal and restart the subscription flow.</p>
                </div>
                <div class="actions">
                    @if (returnUrl) {
                    <a class="primary-link" [href]="returnUrl">Return to portal</a>
                    }
                    @if (!returnUrl) {
                    <a class="primary-link" href="/">Go to registration home</a>
                    }
                </div>
            </section>
            }

            @if (tenantId) {
            <section class="card">
                <div class="card-header">
                    <h3>Select your Atlas plan</h3>
                    <p>Upgrade any time. Billing starts after checkout.</p>
                    <div class="helper">Subscribing tenant: {{ tenantId }}</div>
                </div>

                @if (plansLoading) {
                <div class="helper">Loading plans...</div>
                }
                @if (plansError) {
                <div class="helper">{{ plansError }}</div>
                }
                @if (!plansLoading && !plansError) {
                <div class="plan-grid">
                    @for (plan of plans; track plan.subscriptionLevel) {
                    <button type="button" class="plan-card" [class.selected]="selectedPlan === plan"
                        (click)="selectPlan(plan)" [disabled]="status.loading">
                        <div class="plan-title">{{ plan.displayName }}</div>
                        <div class="plan-price">{{ formatPlanPrice(plan) }} <span>/ {{ planInterval(plan) }}</span>
                        </div>
                        <div class="plan-detail">{{ plan.displayDetail }}</div>
                    </button>
                    }
                </div>
                }

                <div class="actions">
                    <button mat-raised-button color="primary" (click)="continueToCheckout()"
                        [disabled]="!canContinueToCheckout()">
                        Continue to Checkout
                    </button>
                    @if (subscriptionBlocked && subscriptionBlockMessage) {
                    <div class="helper">{{ subscriptionBlockMessage }}</div>
                    }
                    @if (status.loading) {
                    <div class="helper">Redirecting to checkout...</div>
                    }
                    @if (!status.loading) {
                    <div class="helper">You can change plans later in Atlas.</div>
                    }
                </div>
            </section>
            }
        </div>
    </div>
</div>